import { resource } from "angular";
import { iCategoryType } from "@/interfaces/categories";

export interface ICategoryTypesApiResource
  extends resource.IResourceClass<resource.IResource<iCategoryType>> {}

(function (angular) {
  "use strict";

  angular.module("app").service("CategoryTypesApi", CategoryTypesApi);

  CategoryTypesApi.$inject = ["$resource", "settings"];

  /**
   * Provides an interface to the CategoryTypesApi API endpoints
   *
   * @returns {Object}
   */
  function CategoryTypesApi($resource, settings) {
    const resource = $resource(
      settings.apiBase + "/category-types/:id",
      {
        id: "@id",
      },
      {
        delete: {
          method: "DELETE",
          responseType: "json",
        },
        get: {
          method: "GET",
          responseType: "json",
          transformResponse: [(response) => response.data[0]],
        },
        post: {
          method: "POST",
          responseType: "json",
        },
        put: {
          method: "PUT",
          responseType: "json",
        },
        query: {
          method: "GET",
          isArray: true,
          responseType: "json",
          transformResponse: [(response) => response.data],
        },
      },
    );

    return resource;
  }
})(angular);
